var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "well" }, [
      _vm.errors && _vm.errors.length
        ? _c("div", { staticClass: "alert alert-danger row" }, [
            _c(
              "ul",
              { staticClass: "col" },
              _vm._l(_vm.errors, function(error) {
                return _c("li", { key: error }, [
                  _vm._v("\n          " + _vm._s(error) + "\n        ")
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-2" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("p", { staticClass: "control-label" }, [
              _vm._v("Current Link Status")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.linkStatus))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-10" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("p", { staticClass: "control-label" }, [
              _vm._v("Current Link Address")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "input-group" }, [
              _c(
                "a",
                {
                  staticClass: "form-control overflow-wrap",
                  attrs: { href: this.linkAddress, target: "_blank" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(this.linkAddress) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "input-group-btn" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { id: _vm.copyLinkButtonId, type: "button" }
                  },
                  [_vm._v("Copy Link")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { id: _vm.copyTokenButtonId, type: "button" }
                  },
                  [_vm._v("Copy Token")]
                )
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-4" }, [
          _vm.editMode === "activationDate"
            ? _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "edit-link-activation" }
                  },
                  [
                    _vm._v(
                      "\n            Current Link Activation Date *\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedLink.activationDateString,
                      expression: "editedLink.activationDateString"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "edit-link-activation",
                    max: _vm.editedLink.expirationDateString,
                    type: "datetime-local"
                  },
                  domProps: { value: _vm.editedLink.activationDateString },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.editedLink,
                        "activationDateString",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            : _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v(
                    "\n            Current Link Activation Date *\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        new Date(
                          _vm.editedLink.activationDateString
                        ).toLocaleString()
                      ) +
                      " " +
                      _vm._s(_vm.timezoneAbbrev) +
                      "\n            "
                  )
                ])
              ]),
          _vm._v(" "),
          _vm.editMode === "expirationDate"
            ? _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "edit-link-expiration" }
                  },
                  [
                    _vm._v(
                      "\n            Current Link Expiration Date *\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedLink.expirationDateString,
                      expression: "editedLink.expirationDateString"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "edit-link-expiration",
                    min: _vm.editedLink.activationDateString,
                    type: "datetime-local"
                  },
                  domProps: { value: _vm.editedLink.expirationDateString },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.editedLink,
                        "expirationDateString",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            : _c("div", [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v(
                    "\n            Current Link Expiration Date *\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        new Date(
                          _vm.editedLink.expirationDateString
                        ).toLocaleString()
                      ) +
                      " " +
                      _vm._s(_vm.timezoneAbbrev) +
                      "\n           "
                  )
                ])
              ]),
          _vm._v(" "),
          _vm.editMode === "licenseEndDate"
            ? _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "edit-link-license-end" }
                  },
                  [_vm._v(" License End Date")]
                ),
                _vm._v(" "),
                _vm.editMode === "licenseEndDate"
                  ? _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.editedLink.licenseEndDateString,
                          expression: "editedLink.licenseEndDateString"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { id: "edit-link-license-end", type: "date" },
                      domProps: { value: _vm.editedLink.licenseEndDateString },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.editedLink,
                            "licenseEndDateString",
                            $event.target.value
                          )
                        }
                      }
                    })
                  : _vm._e()
              ])
            : _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v(" License End Date")
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.editedLink.licenseEndDateString) +
                      "\n            "
                  )
                ])
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4" }, [
          _vm.editMode === "totalCapacity"
            ? _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "edit-link-total-capacity" }
                  },
                  [
                    _vm._v(
                      "\n            Current Link Total Capacity\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedLink.totalCapacity,
                      expression: "editedLink.totalCapacity"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: {
                    id: "edit-link-total-capacity",
                    type: "number",
                    min: "1"
                  },
                  domProps: { value: _vm.editedLink.totalCapacity },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(
                        _vm.editedLink,
                        "totalCapacity",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            : _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v(
                    "\n            Current Link Total Capacity\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.editedLink.totalCapacity) +
                      "\n            "
                  )
                ])
              ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("p", { staticClass: "control-label" }, [
              _vm._v("Current Link Used Capacity")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.editedLink.usedCapacity))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("p", { staticClass: "control-label" }, [
              _vm._v("Current Link Remaining Capacity")
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.editedLink.remainingCapacity))])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4" }, [
          _vm.editMode === "notes"
            ? _c("div", { staticClass: "form-group" }, [
                _c(
                  "label",
                  {
                    staticClass: "control-label",
                    attrs: { for: "edit-link-notes" }
                  },
                  [_vm._v("Current Link Notes")]
                ),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.editedLink.notes,
                      expression: "editedLink.notes"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { id: "edit-link-notes", rows: "5" },
                  domProps: { value: _vm.editedLink.notes },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.editedLink, "notes", $event.target.value)
                    }
                  }
                })
              ])
            : _c("div", { staticClass: "form-group" }, [
                _c("p", { staticClass: "control-label" }, [
                  _vm._v("Current Link Notes")
                ]),
                _vm._v(" "),
                _c("p", [
                  _c("pre", { staticClass: "notes" }, [
                    _vm._v(_vm._s(_vm.editedLink.notes || "(none)"))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-xs btn-link",
                      on: {
                        click: function($event) {
                          return _vm.setEditMode("notes")
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-pencil" }),
                      _vm._v(" Edit\n            ")
                    ]
                  )
                ])
              ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c("i", [
          _vm._v("\n        " + _vm._s(_vm.timezoneMessage) + "\n      ")
        ])
      ]),
      _vm._v(" "),
      _c("p", [
        _c(
          "button",
          {
            staticClass: "btn btn-primary",
            attrs: { disabled: !_vm.isLinkEdited },
            on: { click: _vm.saveLink }
          },
          [_vm._v("\n        Save\n      ")]
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted" }, [
        _vm._v("Last updated " + _vm._s(_vm.updatedString))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }